import { render, staticRenderFns } from "./PendingProductsDialog.vue?vue&type=template&id=82b4540a"
import script from "./PendingProductsDialog.vue?vue&type=script&lang=js"
export * from "./PendingProductsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports